// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PDF from "../../assets/attachment-icons/pdf.svg";
import PNG from "../../assets/attachment-icons/png.svg";
import JPG from "../../assets/attachment-icons/jpg.svg";
import JPEG from "../../assets/attachment-icons/Jpeg.svg";
import DOC from "../../assets/attachment-icons/doc.svg";
import DOCX from "../../assets/attachment-icons/docx.svg";
import JSONFILE from "../../assets/attachment-icons/json.svg";
import XLS from "../../assets/attachment-icons/xls.svg";
import XLSM from "../../assets/attachment-icons/xlsm.svg";
import XML from "../../assets/attachment-icons/xml.svg";
import AVI from "../../assets/attachment-icons/avi.svg";
import CSV from "../../assets/attachment-icons/csv.svg";
import GIF from "../../assets/attachment-icons/GIF.svg";
import MOV from "../../assets/attachment-icons/MOV.svg";
import WEBM from "../../assets/attachment-icons/WEBM.svg";
import M4V from "../../assets/attachment-icons/M4V.svg";
import MID from "../../assets/attachment-icons/mid.svg";
import SVG from "../../assets/attachment-icons/svg.svg";
import XLSX from "../../assets/attachment-icons/Xlsx.svg";
import PPT from "../../assets/attachment-icons/ppt.svg";
import PPTX from "../../assets/attachment-icons/PPTX.svg";
import MP4 from "../../assets/attachment-icons/mp4.svg";
import WAV from "../../assets/attachment-icons/wav.svg";
import TXT from "../../assets/attachment-icons/txt.svg";
import MP3 from "../../assets/attachment-icons/mp3.svg";
import OGG from "../../assets/attachment-icons/ogg.svg";
import MKV from "../../assets/attachment-icons/mkv.svg";
import FLAC from "../../assets/attachment-icons/Flac.svg";
import AAC from "../../assets/attachment-icons/AAC.svg";
import GP from "../../assets/attachment-icons/3GP.svg";
import AMR from "../../assets/attachment-icons/AMR.svg";
import M4A from "../../assets/attachment-icons/m4a.svg";
import FLV from "../../assets/attachment-icons/FLV.svg";

// Internal Imports
import { GlobalUtils } from "../../utils";

// ICON MAPPING
const imgData = {
  pdf: PDF,
  png: PNG,
  jpg: JPG,
  jpeg: JPEG,
  doc: DOC,
  docx: DOCX,
  json: JSONFILE,
  xls: XLS,
  xlsm: XLSM,
  xml: XML,
  avi: AVI,
  csv: CSV,
  gif: GIF,
  mov: MOV,
  webm: WEBM,
  m4v: M4V,
  mid: MID,
  svg: SVG,
  xlsx: XLSX,
  ppt: PPT,
  pptx: PPTX,
  mp4: MP4,
  wav: WAV,
  txt: TXT,
  mp3: MP3,
  ogg: OGG,
  mkv: MKV,
  flac: FLAC,
  aac: AAC,
  "3gp": GP,
  amr: AMR,
  m4a: M4A,
  flv: FLV,
};

export default class AttachmentItem extends Component {
  state = { isVideo: false };

  componentDidMount() {
    const isVideoAttachment = this.props.Name.split(".");
    if (
      isVideoAttachment[isVideoAttachment.length - 1] === "webm" ||
      isVideoAttachment[isVideoAttachment.length - 1] === "mp4"
    ) {
      this.setState({ isVideo: true });
    }
  }

  bytesToSize = bytes => {
    const sizes = ["Bytes", "KB", "MB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    // eslint-disable-next-line no-restricted-properties
    return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
  };

  _getFileMapping = filename => {
    const extension = filename && filename.split(".").pop();
    return imgData[extension] ? imgData[extension] : imgData.doc;
  };

  render() {
    console.debug(this.props.Name, "check");
    return (
      <div
        className="attachment-item-container"
        onKeyPress={() => null}
        role="button"
        tabIndex="0"
        onClick={() => this.props.viewFile(this.state.isVideo)}>
        {this.state.isVideo && (
          <div>
            {" "}
            <video src={this.props.Link} controls width={235} height={150}>
              <track kind="captions" srcLang="en" label="english_captions" />
            </video>
          </div>
        )}
        <div className="attachment-first-section-box">
          <img
            src={this._getFileMapping(this.props.Name)}
            className="attachment-item-image"
            alt="attachment"
          />
          <div className="attachment-item-first-section">
            <span className="attachment-item-name">{this.props.Name}</span>
            {!this.props.isSharedDocument && (
              <span className="attachment-item-trash">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  onClick={e => this.props.removeItem(e)}
                  className=""
                />
              </span>
            )}
          </div>
          <div className="attachment-item-size">
            {this.bytesToSize(this.props.FileSize)}
          </div>
        </div>
        <div className="attachment-horizontal-line " />
        <div className="attachment-user-info">
          <span>{this.props.user && this.props.user.name}</span>
          <span>
            {this.props.UploadedAt
              ? GlobalUtils.formatDate(this.props.UploadedAt, "ll") || "-"
              : ""}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AttachmentComponent/AttachmentItem.js